import * as React from 'react'

import { cn } from '@/lib/utils'

export type StatsGridProps = React.HTMLAttributes<HTMLDivElement> & {
  columns?: 2 | 3 | 4
}

/** 统计信息网格：用于页面概览区，默认 4 列以适配 PC 高密度布局；移动端自动降列避免卡片被挤压。 */
export function StatsGrid({ columns = 4, className, ...props }: StatsGridProps) {
  const colsClassName =
    columns === 2
      ? 'grid-cols-2'
      : columns === 3
        ? 'grid-cols-1 sm:grid-cols-3'
        : 'grid-cols-2 lg:grid-cols-4'

  return <div className={cn('grid gap-3 sm:gap-4', colsClassName, className)} {...props} />
}

export type StatCardProps = React.HTMLAttributes<HTMLDivElement> & {
  label: React.ReactNode
  value: React.ReactNode
  hint?: React.ReactNode
}

/** 统计卡片：value 为主层级、label 次之，hint 仅辅助说明。 */
export function StatCard({ label, value, hint, className, ...props }: StatCardProps) {
  return (
    <div className={cn('rounded-lg border bg-card px-4 py-3', className)} {...props}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 space-y-1">
          <div className="text-xs font-medium text-muted-foreground">{label}</div>
          <div className="truncate text-2xl font-semibold leading-none">{value}</div>
        </div>
        {hint ? <div className="shrink-0 text-xs text-muted-foreground">{hint}</div> : null}
      </div>
    </div>
  )
}

